"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Locations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const offices = [{
    city: "LAKELAND",
    description: "Homeowners can request a bathroom remodel quote for projects in Lakeland. Local services include shower remodels, tub replacements, and new tile installation. Updates often involve flooring, vanities, and modern fixtures. Plans can also incorporate improved lighting, increased storage, and complete layout updates to improve the space."
  }, {
    city: "WINTER HAVEN",
    description: "A bathroom remodel quote for Winter Haven properties covers various interior updates. Options include shower remodels, tub replacements, and tile work for floors or walls. Projects typically feature new flooring, vanities, and fixtures. Layout updates can help optimize the room with better lighting and storage solutions."
  }, {
    city: "BARTOW",
    description: "In Bartow, residents can obtain a bathroom remodel quote for home improvement tasks. Services provide for shower remodels, tub replacements, and professional tile application. Common upgrades include flooring, vanities, and plumbing fixtures. Layout updates often focus on maximizing storage and installing efficient lighting."
  }, {
    city: "AUBURNDALE",
    description: "Request a bathroom remodel quote in Auburndale to plan for interior changes. Local providers handle shower remodels, tub replacements, and tile installation. Renovations frequently include new flooring, vanities, and updated fixtures. Layout updates are available to improve lighting and add functional storage."
  }, {
    city: "HAINES CITY",
    description: "For those in Haines City, a bathroom remodel quote helps outline the costs for various updates. This includes shower remodels, tub replacements, and custom tile work. Projects often involve replacing flooring, vanities, and fixtures. Layout updates can be designed to include better lighting and more storage."
  }, {
    city: "DAVENPORT",
    description: "Davenport residents can get a bathroom remodel quote for their renovation needs. Services include shower remodels, tub replacements, and tile flooring or wall work. Updates usually consist of new flooring, vanities, and fixtures. Layout updates aim to enhance the area with improved lighting and storage."
  }, {
    city: "LAKE WALES",
    description: "A bathroom remodel quote in Lake Wales provides details for updating the home. Local options cover shower remodels, tub replacements, and tile installation. Standard projects include new flooring, vanities, and fixtures. Layout updates can also address lighting needs and storage requirements."
  }, {
    city: "MULBERRY",
    description: "Homeowners in Mulberry can request a bathroom remodel quote for their next project. Available services include shower remodels, tub replacements, and tile work. Renovations often feature new flooring, vanities, and fixtures. Layout updates help with the placement of lighting and storage components."
  }];
  return <section data-section-id="17689" id="request-a-bathroom-remodel-quote-near-lakeland" className="bg-background text-foreground py-32 md:py-44 font-default">
      <div className="max-w-[1440px] mx-auto px-6 md:px-16 lg:px-24">
        <div ref={ref} className="transition-all duration-[900ms] ease-out" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          <p className="text-xs font-medium uppercase text-muted-foreground" style={{
          letterSpacing: "0.22em"
        }}>
            Service Locations
          </p>
          <h2 className="font-default font-light text-foreground mt-8 max-w-4xl" style={{
          fontSize: "clamp(1.9rem, 3.2vw, 2.9rem)",
          letterSpacing: "-0.015em",
          lineHeight: "1.1"
        }}>Bathroom Remodel Service Areas Near Lakeland, FL</h2>
        </div>

        <div className="mt-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-16 lg:gap-x-12 relative transition-all duration-[900ms] ease-out" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transitionDelay: "240ms"
      }}>
          {offices.map((office, i) => <div key={office.city} data-index={i} className={`group relative py-4 lg:py-0`}>
              {i % 4 !== 0 && <div className="hidden lg:block absolute left-0 top-0 bottom-0 w-px bg-border -ml-6" aria-hidden="true" />}
              
              <p className="text-xs font-medium uppercase text-muted-foreground transition-colors duration-[260ms] ease-out group-hover:text-foreground" style={{
            letterSpacing: "0.22em"
          }}>
                {office.city}
              </p>

              <p className="mt-8 text-sm text-muted-foreground leading-relaxed" style={{
            letterSpacing: "0.04em"
          }}>
                {office.description}
              </p>

              <div className="mt-10">
                <Link to="/contact" className="inline-block text-foreground text-sm tracking-[0.04em] pb-1 border-b transition-all duration-[260ms] ease-out" style={{
              borderBottomWidth: "1px",
              borderBottomColor: "var(--chart-1)",
              paddingBottom: "4px"
            }}>
                  <span className="inline-block transition-all duration-[260ms] ease-out group-hover:pb-[6px] group-hover:border-foreground">
                    Request a quote
                  </span>
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}